export const root = "rqcjj3w";
export const title = "t1vcoild";
export const subTitle = "seun7d9";
export const statContainer = "snc5kvk";
export const icon = "i174nmhe";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");